import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "./SearchBox";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/news", label: "娱乐资讯", end: false },
  { to: "/movies", label: "影视推荐", end: false },
  { to: "/community", label: "社区", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2 cursor-pointer" aria-label="色花堂首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-extrabold tracking-wide text-foreground-950">
            色花堂
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-50 font-semibold text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden w-72 md:block lg:w-80">
            <SearchBox />
          </div>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 hover:bg-background-100 lg:hidden cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <div className="mb-3 md:hidden">
            <SearchBox inputId="mobile-site-search" onNavigate={() => setMenuOpen(false)} />
          </div>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-sm transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-50 font-semibold text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}